/* eslint-disable react/jsx-props-no-spreading */
import Icon from "../Icon";

const ListSolidV6 = (props) => (
  <Icon {...props} name="List Solid V6">
    <path d="M2.75 1.5c.416 0 .75.336.75.75v1.5c0 .416-.334.75-.75.75h-1.5a.749.749 0 0 1-.75-.75v-1.5a.75.75 0 0 1 .75-.75h1.5zM15 2a1 1 0 1 1 0 2H6a1 1 0 1 1 0-2h9zm0 5a1 1 0 1 1 0 2H6a1 1 0 1 1 0-2h9zm0 5a1 1 0 1 1 0 2H6a1 1 0 1 1 0-2h9zM.5 7.25c0-.416.336-.75.75-.75h1.5c.416 0 .75.334.75.75v1.5c0 .416-.334.75-.75.75h-1.5a.749.749 0 0 1-.75-.75v-1.5zm2.25 4.25c.416 0 .75.334.75.75v1.5c0 .416-.334.75-.75.75h-1.5a.749.749 0 0 1-.75-.75v-1.5c0-.416.336-.75.75-.75h1.5z" />
  </Icon>
);

export default ListSolidV6;
